import nodeClient from "./node-client";

const endpoints = {
  user: "/service/private/v0/list/user",
  product: "/service/private/v0/list/product",
  branch: "/service/private/v0/list/branch",
  customer: "/service/private/v0/patient/patientList",
  bank: "/service/private/v0/bank/list",
  entity: "/service/protected/v0/entityMaster/list",
  doctor: "/service/private/v0/doctor/find/all",
  hsn: "/service/private/v0/hsn/master/find/all",
  distributor: "/service/private/v0/distributor/find/all",
  stockAuditReport: "/service/protected/v0/stock/audit/request/report",
  stockTransferReport: "/service/protected/v0/stock/transfer/list",
  stockRequestReport: "/service/protected/v0/stock/request/list",
  medicineWiseStockAuditReport:
    "/service/protected/v0/stock/audit/report/medicine",
  professionMaster: "/service/protected/v0/profession/list",
  transport: "/service/private/v0/transport/find/all",
  medicineWiseStockTransferReport:
    "/service/protected/v0/stock/transer/medicine/wise/report",
  medicineWiseStockRequestReport:
    "/service/protected/v0/medicine/wise/stock/request",
  serviceItemMaster: "/service/protected/v0/service/products/list",
  discountSlabReport: "/service/private/v0/discount/program/list",
  discountProgramReport: "/service/private/v0/loyalty/program/list",
  manufacturer: "/service/private/v0/manufacturer/report",
  manufacturerGroup: "/service/protected/v0/manufacturer/group/list",
  branchGroup: "/service/private/v0/branch/group/list",
  specialityMaster: "/service/protected/v0/speciality/list",
  frequencySlabReport: "/service/private/v0/frequncy/list",
  cacUser: "/service/private/v0/admin/list/users",
  doctorCommissionProgramReport: "/service/private/v0/doctor/commission/list",
  modeConfigPricingReport: "/service/private/v0/modeConfig/list",
};

export const fetchReportData = async (data) => {
  const response = await nodeClient.post(endpoints[data.identifier], data);
  return response?.data?.result;
};
